import React, { Suspense } from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';
import Picture from "@/js/react/src/components/ui/Picture";
import IconRegistry from '@/js/react/src/components/ui/icons/IconRegistry';
import { Newspaper } from "@/js/react/src/components/ui/icons/classic/regular";

export default function Hit({ hit, additionalData }: componentTypes.HitProps) {
  const {
    title,
    image,
    section,
    content,
    shortDescription,
  } = hit;

  const {
    hitClasses,
    categoriesLabels,
    categoriesIcons,
  } = additionalData;

  const iconKey = categoriesIcons[section] ?? '';
  const ItemIcon = iconKey && iconKey in IconRegistry
    ? (IconRegistry[iconKey as keyof typeof IconRegistry] as React.ComponentType<any>)
    : null;
  const text = shortDescription ?? content ?? '';
  return (
    <div className={`${hitClasses ?? 'w-full'} rounded-lg py-6 md:py-8 border-b border-grey-100 first:pt-0 last:pb-0 last:border-0`}>
      <a
        href={Craft.getSiteUrl(hit.uri, '')}
        className="group/card w-full relative no-underline transition-all overflow-hidden flex justify-start md:items-center gap-4 md:gap-8 bg-light"
      >
        {image && (<Picture
          pictureClasses="block aspect-square rounded-lg size-20 md:size-39 overflow-hidden shrink-0"
          image={image}
          classes="size-full"
          defaultTransform="all"
          loading="lazy"
        />)}
        <div className="flex flex-1 flex-col justify-center">
          <div className="flex justify-start text-grey-500 items-center gap-2 mb-3 self-start grow-0">
            {ItemIcon && (
              <Suspense fallback={<Newspaper iconClass="h-3 md:h-3.5 grow-0" />}>
                {React.createElement(ItemIcon, { iconClass: 'h-3 md:h-3.5 grow-0' })}
              </Suspense>
            )}
            {categoriesLabels && section &&
              (<span className="text-2xs/3 md:text-xs/5">{categoriesLabels[section] ?? section}</span>)
            }
          </div>
          <div className="text-dark text-md/6 md:text-lg/7 font-semibold">{title}</div>
          {text &&
            (<div className="text-grey-500 text-xs/6 md:text-base/8 font-normal line-clamp-3 overflow-hidden">{text}</div>)
          }
        </div>
      </a>
    </div>
  );
}
